import Headers from './components/Headers.vue'
import Footers from './components/Footers.vue'
import Hero from './components/Hero.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import Indexslides from './components/Indexslides.vue'
import Carousel from './components/Carousel.vue'
import Btn from './components/Btn.vue'
import Faq from './components/Faq.vue'
import Slice from './components/Slice.vue'
import OlinaceCarousel from './components/OlinaceCarousel.vue'
import { createApp } from 'vue'

export default function partials(){
  return new Promise((resolve) => {
    const app = createApp({
      components: {
        Headers: Headers,
        Footers: Footers,
        Hero: Hero,
        Breadcrumb: Breadcrumb,
        Indexslides: Indexslides,
        Carousel: Carousel,
        Btn: Btn,
        Slice: Slice,
        Faq: Faq,
        Olinacecarousel: OlinaceCarousel,
      }
    });
    
    // Vue.jsを#appにマウント
    app.mount('#app');
    resolve();
  });
}
